import { useEffect, useContext, FC } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { Redirect } from 'react-router-dom';
import SplitIOTreatment from '../../components/splitio/splitioTreatment';
import splitsDictionary from '../../services/utils/splitsDictionary';
import { getRealm } from '../utils/getRealm';
import { logout } from '../../modules/user_api';
import AuthContext from '../../context/AuthContext';

const LegacyLogOut: FC = () => {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { userLoggedIn } = useSelector((state: any) => state.user, shallowEqual);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
  }, []);

  if (!userLoggedIn) {
    return <Redirect to="/" />;
  } else {
    return <div>Logging out...</div>;
  }
};

const KeycloakLogOut: FC = () => {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { userLoggedIn } = useSelector((state: any) => state.user, shallowEqual);
  const dispatch = useDispatch();
  const keycloak = useContext(AuthContext);

  keycloak.onAuthLogout = () => {
    dispatch(logout());
  };

  useEffect(() => {
    keycloak.logout();
  }, []);

  if (!userLoggedIn) {
    return <Redirect to="/" />;
  } else {
    return <div>Logging out...</div>;
  }
};

const LogOut: FC = () => {
  const realm = getRealm(window.location.host);
  return (
    <SplitIOTreatment
      featureName={splitsDictionary.KEYCLOAK_AUTH.name}
      treatmentValue="on"
      trafficType={splitsDictionary.KEYCLOAK_AUTH.traffic_type}
    >
      {(treatment: string) => {
        if (treatment === 'on' && realm !== false) {
          return <KeycloakLogOut />;
        } else if (treatment === 'off' || !realm) {
          return <LegacyLogOut />;
        } else {
          return <>Loading...</>;
        }
      }}
    </SplitIOTreatment>
  );
};

export default LogOut;
